/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import { Customer, Email, Influencer } from "../../@types";
import { format } from "date-fns";
import { useHistory } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import styled from "styled-components";
import { TableHeader } from "semantic-ui-react";
import UsersIcon from "../SVGIcons/UsersIcon";
import api from "../../network/api";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      marginTop: "2rem",
      background: "#000",
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
      background: "#000",
    },
    table: {
      width: "100%",
      background: "#000",
      color: "#fff",
      borderSpacing: "0 0px",
      borderCollapse: "separate",
      borderRadius: "15px",
      overflow: "hidden",
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    tableRow: {
      background: "#E9F4F9",
      transition: "all 0.2s all",
      opacity: "0.95",
      "&:hover": {
        cursor: "pointer",
        background: "#E9F4F9",
        opacity: "1",
      },
    },
    cell: {
      color: "#000",
      fontWeight: "bold",
    },
    headerCell: {
      color: "#000",
      fontWeight: "bold",
      "&:hover": {
        cursor: "pointer",
      },
    },
  })
);

const EmailHistoryTable: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  let [emails,setEmails]= useState<Email[]>([])
  let [loading,setLoading] = useState(true);

  

  const onUserSelect = (customerId: number, email: string) => {
    api.post("/influencer/read", {
      email: email,
      is_read: true,
    });
    // history.push(`/influencer/${email}`);
  };

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const { data: emails } = await api.get("/messages/history");
        console.log(emails)
        setEmails(emails)
        setLoading(false)
        // alert(emails.length)
      } catch (error) {
          console.log(error)
          setLoading(false)
          toast.error("Could not load emails")
      }
    };

    fetchEmails()

    
  }, []);


  return (
    <div className={classes.root}>
      {/* <div
        style={{
          display:
          emails.filter((email:any) => email.is_ordered).length > 0
              ? "flex"
              : "none",
          fontSize: "1.3rem",
          alignItems: "cetner",
          marginLeft: "40px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            height: "20px",
            width: "20px",
            marginRight: "10px",
            transform: "translateY(-2px)",
          }}
        >
          <UsersIcon />
        </div>
        {emails.filter((email:any) => email.is_ordered).length}
        {emails.filter((email:any) => email.is_ordered).length === 1
          ? " influencer"
          : " influencers"}
      </div> */}
      

      <Paper className={classes.paper}>
        <TableContainer>
          {loading ? (
            <LoadDiv>
              <BeatLoader color="#ffcc00" />
            </LoadDiv>
          ) : (
            <>
              {emails
                .length === 0 ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                    color: "white",
                  }}
                >
                  No email on this list
                </div>
              ) : (
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size="medium"
                  aria-label="enhanced table"
                >
                  <TableBody>
                    {emails
                      
                      .map((email) => (
                        <TableRow
                          key={email.id}
                          aria-checked={true}
                          onClick={() =>
                            onUserSelect(email.id, email.email)
                          }
                          selected={false}
                          className={classes.tableRow}
                        >
                         
                          <TableCell align="left" className={classes.cell}>
                            {email.email}
                          </TableCell>

                          <TableCell align="left" className={classes.cell}>
                            {email.created_at
                              ? format(
                                  new Date(email.created_at),
                                  "dd-MM-yyyy"
                                )
                              : "-----"}
                          </TableCell>

                          <TableCell align="left" className={classes.cell}>
                            <div
                              style={{
                                paddingInline: "10px",
                                paddingBlock: "5px",
                                backgroundColor: "#ffcc00",

                                borderRadius: "10px",
                                // display: !email.is_read ? "flex" : "none",
                                width: "50px",
                                justifyContent: "center",
                              }}
                            >
                              New
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              )}
            </>
          )}
        </TableContainer>
      </Paper>
      </div>

  );
};

const LoadDiv = styled.div`
  height: 50vh;
  width: 100%;
  margin-top: "400px";
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default EmailHistoryTable;
